<template>
  <div class="storeView">
    <store-method></store-method>
  </div>
</template>

<script>
// @ is an alias to /src
import storeMethod from "@/components/methods/storeMethod.vue";

export default {
  name: "store",

  components: {
    storeMethod
  },
  created() {}
};
</script>

